import {Injectable} from "@angular/core";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {ICrudReq, ICrudRes} from "../../../interface/http.config";
import {ToastrService} from "ngx-toastr";


@Injectable()
export class CrudService {

  page: number = 1;
  perPage: number = 20;
  provider: string = '';
  orderBy: string = '';
  orderDirection: string = '';
  filters: Record<string, any> = [];
  filterTypes: Record<string, any> = [];
  filterLabels: Record<string, any> = [];

  constructor(protected httpClient: HttpClient, private toastr: ToastrService) {}


  setProvider(provider: string) {
    this.provider = provider;
    this.page = 1;
    this.orderBy = 'id';
    this.orderDirection = 'desc';
    this.filters = {};
    this.filterTypes = {};
    this.filterLabels = {};
  }

  async list(csv = false, extraParams: any = {}): Promise<ICrudRes> {

    const filterParams: Record<string, any> = {};

    for (const param of Object.keys(this.filters)) {
      filterParams['filters[' + param + ']'] =  this.filters[param];
    }


    for (const param of Object.keys(this.filterTypes)) {
      filterParams['filterTypes[' + param + ']'] =  this.filterTypes[param];
    }

    const {searchProvider = null, ...searchParams  } = extraParams;

    const params = {
      perPage: this.perPage,
      page: this.page,
      ...filterParams,
      orderBy: this.orderBy,
      orderDirection: this.orderDirection,
      csv,
      ...searchParams,
    };


    const provider = searchProvider || this.provider;
    if (csv) {

      const response = await this.httpClient.get(environment.apiUrl + '/' + provider + (csv ? '/csv' : ''), {
        responseType: 'text',
        params,
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        }
      }).toPromise();

      this.downLoadFile(response, 'text/csv');

    } else {

      try {
        const {csv, ...otherParams} = params;

        const response = await this.httpClient.get(environment.apiUrl + '/' + provider + (csv ? '/csv' : ''), {
          params: otherParams,
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
          }
        }).toPromise();

        return response as any;

      } catch (err: any) {
        if (err instanceof HttpErrorResponse) {
          if (err?.error?.error === 'broken_jwt_header'
            || err?.error?.error === 'broken_tfa_jwt_header'
          ) {
            localStorage.removeItem('jwtToken');
            document.location = 'auth/login';
          }
        }
        this.toastr.error('Cannot load data', 'Server Error');
        console.error(err);
      }

    }

    return {} as any;
  }

  downLoadFile(data: any, type: string) {
    let blob = new Blob([data], { type: type});
    let url = window.URL.createObjectURL(blob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert( 'Please disable your Pop-up blocker and try again.');
    }
  }

  item(item: any): Promise<any> {
    return this.httpClient.get(environment.apiUrl + '/' + this.provider + '/item/' + item.id, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    }).toPromise() as any;
  }
  get(path: string): Promise<any> {
    return this.httpClient.get(environment.apiUrl + '/' + path, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    }).toPromise() as any;
  }

  save(item: any): Promise<{ document: {id: string} }> {
    const body = {
      id: item.id,
      data: item,
    };

    const promise = this.httpClient.post(environment.apiUrl + '/' + this.provider , body, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    }).toPromise() as any;

    return promise.catch((err: HttpErrorResponse) => {
      this.toastr.error(err.error.message, 'Error');
    }).then((res: any) => {
      if (res) {
        this.toastr.success('Saved', 'Success');
      }

      return res;
    });
  }

  delete(item: any): Promise<any> {
    return this.httpClient.delete(environment.apiUrl + '/' + this.provider + '/' + item.id, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    }).toPromise() as any;
  }

  async getList(manager: string, key: string, value: string) {
    const params = {
      perPage: 100000,
      page: 1,
      filters: [],
      orderBy: 'id',
      orderDirection: 1,
    };

      const all = await this.httpClient.get(environment.apiUrl + '/' + manager, {
        params,
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        }
      }).toPromise() as any;

      const map: Record<string, string> = {};

      for (const model of all.list) {
        map[model[key]] = value.split(',').map((key: string) => model[key]?.toString())
          .join(' ');
      }

      return map;
  }

  async sendForm(url: string, formData: FormData) {
    const result = await this.httpClient.post(environment.apiUrl + '/' + url, formData, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        'enctype': 'multipart/form-data',
      }
    }).toPromise() as any;

    return result;
  }
  async sendJson(url: string, data: object) {
    const result = await this.httpClient.post(environment.apiUrl + '/' + url, data, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    }).toPromise() as any;

    return result;
  }
}
